(function($) {
    $('.paragraph-dropcap>p:first-child').each(function () {
        var text = $.trim(this.innerHTML),
        firstLetter = text[0],
        dropCap = '<span class="dropcap">' + firstLetter + '</span>';

        this.innerHTML = text.replace(firstLetter, dropCap);
    });
})(jQuery);